import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

const refs = {
  formEl: document.querySelector('form'),
};

function makePromise(state, delay) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (state === 'fulfilled') {
        resolve(delay);
      } else {
        reject(delay);
      }
    }, delay);
  });
}

function handleSubmit(event) {
  event.preventDefault();

  const form = event.target;

  const delayInputValue = Number(form.elements.delay.value);
  const radioStateValue = form.elements.state.value;

  makePromise(radioStateValue, delayInputValue)
    .then(delay => {
      iziToast.success({
        message: `✅ Fulfilled promise in ${delay}ms`,
        messageColor: 'white',
        backgroundColor: 'rgb(99, 212, 99)',
        position: 'topRight',
      });
    })
    .catch(delay => {
      iziToast.error({
        message: `❌ Rejected promise in ${delay}ms`,
        messageColor: 'white',
        backgroundColor: 'tomato',
        iconColor: 'darkred',
        position: 'topRight',
      });
    });

  form.reset();
}

refs.formEl.addEventListener('submit', handleSubmit);
